import { deletedUserString } from "../Constants"

export const deletedUserMixin = {
    methods: {
        checkIfUserIsDeleted(userId=""){
            return userId.includes(deletedUserString)
        }
    }
}